import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import { Button, EmptyState } from '../components/ui';

export default function LabelTemplatesPage({ onNavigate }) {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchList = useCallback(async () => {
    setLoading(true);
    try {
      const r = await api.get('/label-templates');
      if (r.data.success) setList(r.data.data || []);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { fetchList(); }, [fetchList]);

  const openDesigner = (id) => {
    try { localStorage.setItem('label_designer_id', id || 'new'); } catch {}
    onNavigate && onNavigate('label-designer');
  };

  const cloneTemplate = async (t) => {
    try {
      let elements = t.elements;
      if (typeof elements === 'string') { try { elements = JSON.parse(elements); } catch { elements = []; } }
      const body = {
        ...t, id: undefined,
        name: t.name + ' (Kopya)',
        code: null,
        is_default: false,
        elements,
      };
      const r = await api.post('/label-templates', body);
      if (r.data.success) {
        await fetchList();
        openDesigner(r.data.data.id);
      }
    } catch (err) { alert(err.response?.data?.message || 'Kopyalanamadı'); }
  };

  const deleteTemplate = async (id) => {
    if (!window.confirm('Bu şablonu silmek istiyor musunuz?')) return;
    try {
      await api.delete('/label-templates/' + id);
      await fetchList();
    } catch (err) { alert(err.response?.data?.message || 'Silinemedi'); }
  };

  return (
    <div className="stocks-page">
      <div className="stocks-topbar">
        <div className="stocks-topbar-left">
          <Button variant="ghost" size="sm" onClick={() => onNavigate && onNavigate('stock-labels')}>← Geri</Button>
          <h2>Etiket Şablonları</h2>
          <span className="stocks-count-badge">{list.length} şablon</span>
        </div>
        <div className="stocks-topbar-right">
          <Button size="sm" onClick={() => openDesigner(null)}>+ Yeni Şablon</Button>
        </div>
      </div>

      <div className="stocks-table-wrap">
        <table className="stocks-table">
          <thead>
            <tr>
              <th>Ad</th>
              <th>Kağıt</th>
              <th>Etiket (mm)</th>
              <th>Düzen</th>
              <th>Eleman</th>
              <th style={{ textAlign: 'right' }}>Eylemler</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={6} className="stocks-table-empty">Yükleniyor...</td></tr>}
            {!loading && list.length === 0 && (
              <tr><td colSpan={6}><EmptyState title="Şablon yok" description="Yeni etiket şablonu oluşturmak için yukarıdaki butonu kullanın." compact /></td></tr>
            )}
            {list.map(t => {
              let els = t.elements;
              if (typeof els === 'string') { try { els = JSON.parse(els); } catch { els = []; } }
              const elCount = Array.isArray(els) ? els.length : 0;
              return (
                <tr key={t.id} className="stocks-table-row" style={{ cursor: 'pointer' }} onClick={() => openDesigner(t.id)}>
                  <td>
                    <strong>{t.name}</strong>
                    {t.is_default && <span style={{ marginLeft: 6, fontSize: '0.66rem', padding: '2px 6px', borderRadius: 4, background: 'rgba(99,102,241,0.15)', color: 'var(--accent-primary, #6366f1)' }}>Varsayılan</span>}
                    {t.code && <div style={{ fontSize: '0.7rem', color: 'var(--text-tertiary)', fontFamily: 'monospace' }}>{t.code}</div>}
                  </td>
                  <td>{t.paper_type === 'thermal' ? 'Termal' : 'A4'} ({parseFloat(t.paper_width).toFixed(0)}×{parseFloat(t.paper_height).toFixed(0)})</td>
                  <td>{parseFloat(t.label_width).toFixed(1)} × {parseFloat(t.label_height).toFixed(1)}</td>
                  <td>{t.cols} × {t.rows} = {t.cols * t.rows}</td>
                  <td style={{ textAlign: 'center' }}>{elCount}</td>
                  <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }} onClick={e => e.stopPropagation()}>
                    <Button variant="ghost" size="sm" onClick={() => openDesigner(t.id)}>Düzenle</Button>
                    {' '}
                    <Button variant="ghost" size="sm" onClick={() => cloneTemplate(t)}>Kopyala</Button>
                    {' '}
                    <Button variant="danger" size="sm" onClick={() => deleteTemplate(t.id)}>Sil</Button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
